import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "network-id-weekly",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Weekly 100% stacked share of network groups among the network ID detections of one tenant and its selected streams, with low-sample and unfinished weeks marked.",
    domain: "network-id",
    visual: "100% stacked bars",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  settings,
  defaultLayoutClassName: "col-span-12",
};
